module.exports = __webpack_public_path__ + "static/quipper-c959efc6b315a21ace72c20916a25679.jpg";